import React from 'react';
import { Bubble, Icon, BubbleProps } from "tea-component";
import classNames from "classnames";
import './index.scss';
import SvgIcon from "@home/components/SvgIcon";

interface HoverIconButtonProps {
  isSvg?: boolean; // 是否使用svg图标
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
  style?: React.CSSProperties;
  type: string;
  disabled?: boolean;
  size?: number;
}

interface IconButtonWithBubbleProps {
  bubbleConfig: BubbleProps;
  iconConfig: HoverIconButtonProps;
}

const HoverIconButton = (props: HoverIconButtonProps) => {
  const { isSvg, className, type, disabled, size, onClick, ...rest } = props;
  // disabled的情况下, 如果不是svg, 是Icon, 无法使用color改变图标颜色, 因为Icon都是背景图片
  const IconButton = isSvg ? SvgIcon : Icon;
  
  return (<div
    className={classNames('dbl-icon-button', {'dbl-icon-button-disabled': disabled}, className)}
    style={{width: size, height: size}}
    onClick={disabled ? undefined : onClick}
    {...rest}
  >
    <IconButton className={'dbl-icon-button_svg'} type={type}/>
  </div>);
  
};

/**
 * 设计新出了一种 鼠标hover后 有背景色的icon, 同时这种经常icon经常需要Bubble弹窗
 */
const IconButtonWithBubble = (props: IconButtonWithBubbleProps) => {
  const { bubbleConfig, iconConfig, } = props;
  
  if (bubbleConfig) {
    return (<Bubble
      dark
      {...bubbleConfig}
    >
      <HoverIconButton
        {...iconConfig}
      />
    </Bubble>);
  }
  
  return (<HoverIconButton
    {...iconConfig}
  />);
};


export default IconButtonWithBubble;